import { createStore } from 'vuex'

export default createStore({
  state: {
    token: window.sessionStorage.getItem("token"),
  },
  getters: {
  },
  mutations: {
    setToken(state,val) { 
      state.token = val 
      window.sessionStorage.setItem("token",val)
    },
    clearToken(state) {
      state.token = ''
      window.sessionStorage.setItem("token",'')
      window.sessionStorage.setItem('userInfo','')
    },
    getToken(state) {
      return state.token
    },
  },
  actions: {
  },
  modules: {
  }
})
